import { DEAL_PHASES } from '../constants/dealPhases'

export function formatMoney(amount) {
  if (amount == null || amount === '') return '$0'
  const n = Number(amount)
  if (Number.isNaN(n)) return String(amount)
  if (n >= 1e6) return `$${(n / 1e6).toFixed(1)}M`
  if (n >= 1e3) return `$${(n / 1e3).toFixed(0)}K`
  return `$${n}`
}

/** Parse user-entered amounts like "$500M", "5M", "1.2B" into a numeric DB value */
export function parseMoneyAmount(value) {
  if (value == null || value === '') return null
  if (typeof value === 'number' && !Number.isNaN(value)) return value

  const raw = String(value).trim().replace(/,/g, '')
  if (!raw) return null

  const plain = raw.replace(/[^\d.-]/g, '')
  if (/^\d+(\.\d+)?$/.test(raw)) return parseFloat(raw)

  const match = raw.match(/([\d.]+)\s*([kmbKMB])?/)
  if (!match) return null

  let n = parseFloat(match[1])
  if (Number.isNaN(n)) return null

  const suffix = (match[2] || '').toLowerCase()
  if (suffix === 'k') n *= 1e3
  else if (suffix === 'm') n *= 1e6
  else if (suffix === 'b') n *= 1e9

  return n
}

export function mapDealFromApi(row, progressPayload) {
  const phase = progressPayload?.currentPhase || row.phase || 'posted'
  const phases = progressPayload?.phases || DEAL_PHASES.map((p) => ({
    key: p.key,
    status: p.key === phase ? 'active' : 'pending',
  }))
  return {
    id: row.id,
    title: row.title,
    gp: row.gp_name || 'GP',
    target: formatMoney(row.target_amount),
    raised: formatMoney(row.current_amount || 0),
    progress: progressPayload?.progress ?? 10,
    currentPhase: phase,
    phases,
    pendingActions: (progressPayload?.pendingActions || []).map((a) => ({
      id: a.id,
      title: a.title,
      actionKey: a.action_key,
      assignedRole: a.assigned_role,
      status: a.status,
    })),
    timeline: (progressPayload?.timeline || []).map((t) => ({
      date: typeof t.date === 'string' ? t.date.slice(0, 10) : t.date,
      event: t.event,
    })),
    participants: progressPayload?.participants || [],
    dealFiles: progressPayload?.files || [],
    isParticipant: !!(row.is_participant || row.isParticipant),
    gpId: row.gp_id,
    description: row.description || '',
    industry: row.industry || '',
    location: row.location || '',
    targetAmount: row.target_amount,
  }
}

export async function fetchDealWithProgress(axios, dealId) {
  const [dealRes, progressRes] = await Promise.all([
    axios.get(`/api/deals/${dealId}`),
    axios.get(`/api/deals/${dealId}/progress`),
  ])
  const row = dealRes.data
  if (!row?.id) {
    throw new Error('Deal not found')
  }
  return mapDealFromApi(row, progressRes.data)
}
